<template>
  <div class="criteria-bar">
    <criteria-list
      :static-criteria="staticCriteria"
      @deleteStaticCriterion="deleteStaticCriterion"
    />
  </div>
</template>

<script>
import CriteriaList from './CriteriaList'

export default {
  name: 'CriteriaBar',
  components: {
    'criteria-list': CriteriaList
  },
  data () {
    return {
      showDebugLogs: false
    }
  },
  props: {
    criteriaData: {
      default: function () {
        return {
          staticCriteria: []
        }
      },
      type: Object
    }
  },
  computed: {
    staticCriteria () {
      let self = this
      let result = []

      if (self.criteriaData) {
        result = self.criteriaData.staticCriteria
      }

      return result
    }
  },
  methods: {
    addStaticCriterion (criterion) {
      this.$emit('addStaticCriterion', { criterion })
    },
    deleteStaticCriterion (criterion) {
      this.$store.commit('deleteCriterion', criterion)
      this.$eventBus.$emit('deleteCriterion', criterion)
    }
  }
}
</script>

<style lang="scss" scoped>
  /*@import "~ui.kit.styling";*/
  @import '../../../kit-components/styling/definitions.scss';

  .criteria-bar {
    background-color: $lightGreyBackground;
    display: block;
    padding: 0 6px;

    .filter-input {
      display: block;
      height: 50px;
      line-height: 50px;

      .grid-filter-text-input {
        display: inline-block;
        height: 38px;
        line-height: 38px;
        vertical-align: middle;
        width: 60%;
        max-width: calc(100% - 510px);
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/grid/Criteria/CriteriaBar.vue